import { render, staticRenderFns } from "./SuspensionList.vue?vue&type=template&id=a87a7710&scoped=true"
import script from "./SuspensionList.vue?vue&type=script&lang=js"
export * from "./SuspensionList.vue?vue&type=script&lang=js"
import style0 from "./SuspensionList.vue?vue&type=style&index=0&id=a87a7710&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87a7710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a87a7710')) {
      api.createRecord('a87a7710', component.options)
    } else {
      api.reload('a87a7710', component.options)
    }
    module.hot.accept("./SuspensionList.vue?vue&type=template&id=a87a7710&scoped=true", function () {
      api.rerender('a87a7710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/SuspensionList.vue"
export default component.exports